<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="title">部门:</span>
        <!-- <el-input
          v-model="parameter.department_id"
          style="width: 200px;"
          placeholder="请输入内容"
        /> -->
        <el-select v-model="parameter.department_id" filterable placeholder="请选择部门" @change="newqwr">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="item">
        <span class="title">投手:</span>
        <!-- <el-input
          v-model="parameter.pitcher_id"
          style="width: 200px;"
          placeholder="请输入内容"
        /> -->
        <el-select v-model="parameter.pitcher_id" :disabled="parameter.department_id==''" filterable placeholder="请选择投手" style="margin-left: 20px;">
          <el-option
            v-for="item in optionstwo"
            :key="item.id"
            :label="item.admin_name"
            :value="item.id"
          />
        </el-select>
      </div>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="search"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
      <el-button
        type="primary"
        icon="el-icon-circle-plus"
        @click="func"
      >添加</el-button>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%;margin-top: 20px;"
      >
        <el-table-column
          prop="ocean_advertisers"
          label="巨量广告"
          width="300"
          align="center"
        >
          <template scope="scope">
            <ExpandClose
              :my-values="scope.row.ocean_advertisers.map((item)=>{
                return `${item.account_name}（${item.account_id}）`
              })"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="start_date"
          label="开始时间"
          align="center"
        >
          <template scope="scope">
            {{ scope.row.start_date }}
          </template>
        </el-table-column>
        <el-table-column
          prop="end_date"
          label="结束时间"
          align="center"
        />
        <el-table-column
          prop="end_date"
          label="操作"
          align="center"
        >
          <template scope="scope">
            <el-button type="primary" size="mini" @click="eiaweq(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="deleteMy(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination-right
      :total="tableData.total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      :title="'绑定关系'"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      width="40%"
    >
      <detailsdialog
        ref="detailsdialogview"
        @updatawe="updatawe"
      />
    </el-dialog>
  </div>
</template>

<script>
import { bindRelationdestroyNative, bindRelationindexNative, iaaMaterialReportdepartmentlistNative, iaapitcherindexNative } from '@/api/TKreleaseGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import ExpandClose from '@/components/ExpandClose/index.vue'
import detailsdialog from './components/detailsdialog.vue'
export default {
  components: {
    PaginationRight,
    ExpandClose,
    detailsdialog
  },
  data() {
    return {
      tableData: {},
      data: [],
      loading: false,
      parameter: {
        page: 1,
        page_size: 10,
        department_id: '',
        pitcher_id: ''
      },
      dialogVisible: false,
      options: [],
      optionstwo: []
    }
  },
  created() {
    this.getDataList()
    this.list()
  },
  methods: {
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await bindRelationindexNative(this.parameter)
      this.tableData = data.data
      this.loading = false
    },
    list() {
      iaaMaterialReportdepartmentlistNative({ page: 1, page_size: 100 }).then((res) => {
        this.options = res.data.list
      })
    },
    newqwr() {
      iaapitcherindexNative({ page: 1, page_size: 100, department_id: this.parameter.department_id }).then((res) => {
        this.parameter.pitcher_id = ''
        this.optionstwo = []
        this.optionstwo = res.data.list
      })
    },
    fetchPageSize(s) {
      this.parameter.page_size = s
      this.getDataList()
    },

    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },
    // 搜索
    search() {
      this.parameter.page = 1
      this.getDataList()
    },

    func() {
      this.dialogVisible = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.detailsdialogview.send(1)
      }, 100)
    },
    eiaweq(item) {
      this.dialogVisible = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.detailsdialogview.send(2, item)
      }, 100)
    },

    // 重置
    reset() {
      this.parameter = {
        page: 1,
        page_size: 10,
        department_id: '',
        pitcher_id: ''
      }
      this.getDataList()
    },

    // 删除
    deleteMy(row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        await bindRelationdestroyNative({ id: row.id })
        this.getDataList()
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      })
    },
    updatawe() {
      this.dialogVisible = false
      this.getDataList()
    }
  }
}
</script>
<style scoped>
.publicItems{
  padding: 20px;
}
.selectionArea {
  display: flex;
}

.content {
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    .item_title {
      display: inline-block;
      width: 100px;
    }

    .item_input {
      width: 200px;
    }
  }
}

.item {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.title {
  display: inline-block;
  margin-right: 10px;
}
</style>

